export class StringHelpers {
  static clampText(
    value: string | undefined,
    maxLength: number
  ): string | undefined {
    if (value === undefined || value.length <= maxLength) {
      return value;
    }
    return value.slice(0, maxLength);
  }
}
